export default __webpack_public_path__ + "static/media/Cart.7b556f08.png";